import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fifa-world-cup/index.vue')
const Rank = () => import('../activity/fifa-world-cup/Rank.vue')
const Record = () => import('../activity/fifa-world-cup/Record.vue')
const Maker = () => import('../activity/fifa-world-cup/Maker.vue')
const Card = () => import('../activity/fifa-world-cup/Card.vue')
const Shop = () => import('../activity/fifa-world-cup/Shop.vue')

export const index: RouteConfig = {
  path: '/activity/fifa-world-cup',
  name: 'fifa_world_cup',
  component: Index,
}

export const record: RouteConfig = {
  path: '/activity/fifa-world-cup/record',
  name: 'fifa_world_cup_record',
  component: Record,
}

export const maker: RouteConfig = {
  path: '/activity/fifa-world-cup/maker',
  name: 'fifa_world_cup_maker',
  component: Maker,
}

export const rank: RouteConfig = {
  path: '/activity/fifa-world-cup/rank',
  name: 'fifa_world_cup_rank',
  component: Rank,
}

export const card: RouteConfig = {
  path: '/activity/fifa-world-cup/card',
  name: 'fifa_world_cup_card',
  component: Card,
}

export const shop: RouteConfig = {
  path: '/activity/fifa-world-cup/shop',
  name: 'fifa_world_cup_shop',
  component: Shop,
}

export default [index, rank, record, maker, card, shop]
